import React, { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

/** Text that flips like a slot machine when it changes. */
export const FlipText: React.FC<{
  text: string;
  className?: string;
}> = ({ text, className }) => {
  const [displayText, setDisplayText] = useState(text);
  const [isFlipping, setIsFlipping] = useState(false);
  const prevTextRef = useRef(text);

  useEffect(() => {
    if (text !== prevTextRef.current) {
      setIsFlipping(true);

      // At the halfway point of the flip, change the text
      const halfwayTimeout = setTimeout(() => {
        setDisplayText(text);
      }, 150);

      // Complete the flip animation
      const completeTimeout = setTimeout(() => {
        setIsFlipping(false);
        prevTextRef.current = text;
      }, 300);

      return () => {
        clearTimeout(halfwayTimeout);
        clearTimeout(completeTimeout);
      };
    }
  }, [text]);

  return (
    <div className="perspective-[400px] overflow-hidden">
      <span
        className={cn(
          "block transition-transform duration-300 ease-in-out",
          isFlipping && "animate-flip-text",
          className
        )}
        style={{
          transformStyle: 'preserve-3d',
          backfaceVisibility: 'hidden',
        }}
      >
        {displayText}
      </span>
    </div>
  );
};
